// chart: source file: csv, xcel, JSON
// data type: dataset, index, datapoint

import type { SDK_AudioPlayer } from "@quickpoint.me/shared";
import { type ReactNode, memo, useRef } from "react";
import { useRecoilValue } from "recoil";
import { type DefaultTheme, ThemeProvider } from "styled-components";
import type { ElementProps } from "../../../functionalComponents/RenderPage";
import useAiAnimation from "../../../lib/animations/aiAnimationHook";
import useTappedAnimation from "../../../lib/animations/tappedAnimationHook";
import { PageElementsFamily, createLocation } from "../../../state/page";
import { IsEmbedded, IsInAuthor } from "../../../state/ui";
import AudioPlayer from "./AudioPlayer";

const audioPlayerFilter = (theme: DefaultTheme): SDK_AudioPlayer => {
	return theme.audioPlayer;
};

const AudioElement = ({ atomId, pageIndex }: ElementProps): ReactNode => {
	const key = createLocation(pageIndex, atomId);
	const elementData = useRecoilValue(PageElementsFamily(key)).data;
	const tapped = elementData.tapped;
	const elRef = useRef(null);
	const isInAuthor = useRecoilValue(IsInAuthor);
	const isEmbedded = useRecoilValue(IsEmbedded);
	useTappedAnimation({ elRef, tapped, atomId });
	useAiAnimation({ elRef, modifier: elementData.modifier });

	const title =
		elementData.content && typeof elementData.content === "string"
			? elementData.content
			: "untitled";
	if (!elementData.url) return <></>;

	return (
		<ThemeProvider theme={audioPlayerFilter}>
			<AudioPlayer
				audioSrc={elementData.url}
				elementIndex={atomId}
				modifier={elementData.modifier}
				tapped={tapped}
				title={title}
				pageIndex={pageIndex}
				isInAuthor={isInAuthor}
				isEmbedded={isEmbedded}
			/>
		</ThemeProvider>
	);
};

export default memo(AudioElement);
